import { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AlertBox from "../../../components/Messages";
import { useUpdatePasswordMutation } from "../../../services/API/ProfileAPI";

function Security() {
  const { t } = useTranslation(["account"]);

  const [formState, setFormState] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [updateUserPassword] = useUpdatePasswordMutation();

  const handleChange = ({ target: { name, value } }) => {
    return setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrMsg("");
    setIsSuccess(false);

    if (
      formState.newPassword === "" ||
      formState.confirmPassword === "" ||
      formState.currentPassword === ""
    ) {
      setErrMsg(t("error.client.missingInput"));
      return;
    }
    if (formState.newPassword !== formState.confirmPassword) {
      setErrMsg(t("error.client.noMatch"));
      return;
    }

    await updateUserPassword({
      newpassword: formState.newPassword,
      password: formState.currentPassword,
    })
      .then(async (result) => {
        if (result?.error?.status === 400) {
          setErrMsg(t("error.server.invalidInput"));
          return;
        }

        if (result?.error?.status === 401) {
          setErrMsg(t("error.server.wrongPassword"));
          return;
        }

        if (result?.error?.status === 500) {
          setErrMsg(t("error.client.ServerError"));
          return;
        }

        if (result?.data === "OK") {
          setIsSuccess(true);
          return;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    setErrMsg("");
    setIsSuccess(false);
  }, [formState]);

  return (
    <Card className="mb-4">
      <Card.Header> {t("changePassword")}</Card.Header>
      <Card.Body>
        <Form>
          <Form.Group className="mb-3" controlId="formCurrentPassword">
            <Form.Label>{t("currentPassword")}</Form.Label>
            <Form.Control
              autoComplete="off"
              name="currentPassword"
              type="password"
              placeholder={t("placeholder.currentPW")}
              onChange={handleChange}
              value={formState.username}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formNewPassword">
            <Form.Label>{t("newPassword")}</Form.Label>
            <Form.Control
              autoComplete="off"
              name="newPassword"
              type="password"
              placeholder={t("placeholder.newPW")}
              onChange={handleChange}
              value={formState.username}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formConfirmPassword">
            <Form.Label>{t("confirmPassword")}</Form.Label>

            <Form.Control
              autoComplete="off"
              name="confirmPassword"
              type="password"
              placeholder={t("placeholder.confirmPW")}
              onChange={handleChange}
              value={formState.username}
            />
          </Form.Group>

          <Button variant="primary" type="submit" onClick={handleSubmit}>
            {t("save")}
          </Button>

          <AlertBox show={isSuccess} message={t("success")} customVariant={"success"} />

          <AlertBox show={errMsg !== ""} message={errMsg} />
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Security;
